import { history, InvenioILSApp } from "@inveniosoftware/react-invenio-app-ils";
import React from "react";
import { createRoot } from "react-dom/client";
import { OverridableContext } from "react-overridable";
import { Router } from "react-router-dom";
import "semantic-ui-less/semantic.less";
import { initialiseReducers } from "./reducers";
import { config } from "./config";
import { overriddenCmps } from "./overridableMapping";

initialiseReducers();

const root = createRoot(document.getElementById("app"));
root.render(
  <Router history={history}>
    <OverridableContext.Provider value={overriddenCmps}>
      <InvenioILSApp config={config} />
    </OverridableContext.Provider>
  </Router>
);
